module.exports = __webpack_public_path__ + "videos/badge_animation.11b6222.mp4";